import { __extends, __rest } from "tslib";
import React from "react";
var InputMaskChildrenWrapper = /** @class */function (_super) {
  __extends(InputMaskChildrenWrapper, _super);
  function InputMaskChildrenWrapper() {
    return _super !== null && _super.apply(this, arguments) || this;
  }
  InputMaskChildrenWrapper.prototype.render = function () {
    // eslint-disable-next-line react/prop-types
    var _a = this.props,
      children = _a.children,
      props = __rest(_a, ["children"]);
    return /*#__PURE__*/React.cloneElement(children, props);
  };
  return InputMaskChildrenWrapper;
}(React.Component);
export default InputMaskChildrenWrapper;